
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perguntas-frequentes",
      function () {
        return require("private-next-pages/perguntas-frequentes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perguntas-frequentes"])
      });
    }
  